import React, { useMemo } from "react";
import { Box, Chip, Grid, ListItem, Typography, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import BorderOuterIcon from "@material-ui/icons/BorderOuter";
import { IPackage, IGame } from "../../../interfaces";

const useStyles = makeStyles((theme) => ({
    chips: {
        display: "flex",
        flexWrap: "wrap",
        minWidth: "100%",
        padding: theme.spacing(0, 2),
    },
    chip: {
        margin: "4px",
    },
    icon: {
        marginRight: theme.spacing(1),
    }
}));

interface IGamePackagesProps {
    packages?: IPackage[];
}

const GamePackages: React.FC<IGamePackagesProps> = ({ packages }) => {
    const [t] = useTranslation();
    const classes = useStyles();

    // Определяем, включено ли глобальное наследование
    const isInherited = useMemo(() => !packages || packages.length === 0, [packages]);

    return (
        <Grid item xs={12}>
            <Box mb={1}>
                <Typography variant="subtitle1">
                    <b>{t("ru.halls.fields.packets")}:</b>
                </Typography>
            </Box>

            {isInherited ? (
                // Явное отображение наследования
                <Typography color="textSecondary" style={{ marginLeft: 8 }}>
                    {t("Настройки наследуются")}
                </Typography>
            ) : (
                // Рендер пакетов, если список переопределен вручную
                packages!.map((item: IPackage) => {
                    const pkg = item.package ?? item;
                    const games = item.games || [];

                    const isAllProvider = games.length === 0;

                    return (
                        <React.Fragment key={pkg.id}>
                            <ListItem disableGutters>
                                <Box display="flex" alignItems="center">
                                    <BorderOuterIcon className={classes.icon} />
                                    <Typography>{pkg.name}</Typography>
                                </Box>
                            </ListItem>

                            <Box className={classes.chips} mb={2}>
                                {isAllProvider ? (
                                    <Chip
                                        className={classes.chip}
                                        label={t("Все игры провайдера")}
                                        color="primary"
                                        variant="outlined"
                                        size="small"
                                    />
                                ) : (
                                    games.map((game: IGame) => (
                                        <Chip
                                            className={classes.chip}
                                            key={game.id}
                                            label={game.name}
                                            size="small"
                                        />
                                    ))
                                )}
                            </Box>
                        </React.Fragment>
                    );
                })
            )}
        </Grid>
    );
};

export default GamePackages;